import {Component, Input} from '@angular/core';
import {ColorSet} from '@domain/textile-data/color-set/color-set';
import {CreelPosition, MaterialType} from '@domain/textile-data/creel/creel-position';
import {MaterialSet} from '@domain/textile-data/textile-data';
import {YarnSet} from '@domain/textile-data/yarn-set/yarn-set';
import {defaultTo, isEqual, size, take} from 'lodash-es';

@Component({
  selector: 'app-preview-for-creel-position',
  templateUrl: './preview-for-creel-position.component.html',
  styleUrls: ['./preview-for-creel-position.component.scss']
})
export class PreviewForCreelPositionComponent {
  @Input() public creelPosition: CreelPosition;
  @Input() public materialSet: MaterialSet;
  @Input() public maxMaterialTypesToShow: number;
  @Input() public gapBetweenColorsInPixels = 8;

  private readonly maxMaterialTypeNameSize = 10;

  public getMaterialTypesToShow(): MaterialType[] {
    return take(this.creelPosition.getUniqueItems(), this.getAmountOfMaterialTypesToShow());
  }

  public moreMaterialTypesAvailable(): boolean {
    return this.getAmountOfMaterialTypesToShow() < size(this.creelPosition.getUniqueItems());
  }

  public showMaterialTypeName(): string {
    return this.getMaterialTypesToShow()
      .map((materialType: MaterialType) => materialType.name)
      .join(', ');
  }

  public isMaterialSetOfTypeColorSet(): boolean {
    return this.materialSet instanceof ColorSet;
  }

  public isMaterialSetOfTypeYarnSet(): boolean {
    return this.materialSet instanceof YarnSet;
  }

  public canShowNameOfFirstColor(): boolean {
    return this.isMaterialSetOfTypeColorSet() && isEqual(size(this.creelPosition.getUniqueItems()), 1);
  }

  public canShowMaterialTypeName(): boolean {
    return this.canShowNameOfFirstColor() || this.isMaterialSetOfTypeYarnSet();
  }

  private getAmountOfMaterialTypesToShow(): number {
    return defaultTo(this.maxMaterialTypesToShow, size(this.creelPosition.getUniqueItems()));
  }
}
